import { Suspense } from "react";
import { Outlet } from "react-router-dom";

export const PublicRoute = () => {
  return (
    <Suspense fallback={null}>
      <Outlet />
    </Suspense>
  );
};
